import type { TNacionalidade } from '@/shared/interfaces/cliente.types'
import { HttpService } from '@/shared/lib/http'

export class GetNacionalidadesService extends HttpService {
  async execute() {
    return this.http.get<TNacionalidade[]>('api/v2/Nacionalidade/lista')
  }
}
